import { FixtureProduct } from './targeting-items.fixture';

export const targetingGroupResults: FixtureProduct[] = [
  {
    incentivioId: 'inc-group-001',
    externalId: 'ext-id-group-001',
    extTargetingId: 'ext-group-001',
    title: 'Burgers',
    productType: 'GROUP',
    locationVariationCount: 2,
    priceVariationCount: 3,
    locations: [
      {
        productTitle: 'Burgers',
        incentivioId: 'inc-group-001',
        externalId: 'ext-id-group-001',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 9990,
        status: 'ACTIVE',
        productId: 'prod-grp-001',
      },
      {
        productTitle: 'Burger Combos',
        incentivioId: 'inc-group-001',
        externalId: 'ext-id-group-001',
        locationName: 'Uptown Store',
        locationId: 'loc-002',
        price: 13990,
        status: 'ACTIVE',
        productId: 'prod-grp-002',
      },
    ],
  },
  {
    incentivioId: 'inc-group-002',
    externalId: 'ext-id-group-002',
    extTargetingId: 'ext-group-002',
    title: 'Sides',
    productType: 'GROUP',
    locationVariationCount: 1,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'Sides',
        incentivioId: 'inc-group-002',
        externalId: 'ext-id-group-002',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 4990,
        status: 'ACTIVE',
        productId: 'prod-grp-003',
      },
    ],
  },
  {
    incentivioId: 'inc-group-003',
    externalId: 'ext-id-group-003',
    extTargetingId: 'ext-group-003',
    title: 'Drinks',
    productType: 'GROUP',
    locationVariationCount: 2,
    priceVariationCount: 2,
    locations: [
      {
        productTitle: 'Drinks',
        incentivioId: 'inc-group-003',
        externalId: 'ext-id-group-003',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 3990,
        status: 'ACTIVE',
        productId: 'prod-grp-004',
      },
    ],
  },
  {
    incentivioId: 'inc-group-004',
    externalId: 'ext-id-group-004',
    extTargetingId: 'ext-group-004',
    title: 'Desserts',
    productType: 'GROUP',
    locationVariationCount: 1,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'Desserts',
        incentivioId: 'inc-group-004',
        externalId: 'ext-id-group-004',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 6990,
        status: 'ACTIVE',
        productId: 'prod-grp-005',
      },
    ],
  },
  {
    incentivioId: 'inc-group-005',
    externalId: 'ext-id-group-005',
    extTargetingId: 'ext-group-005',
    title: 'Salads',
    productType: 'GROUP',
    locationVariationCount: 2,
    priceVariationCount: 1,
    locations: [
      {
        productTitle: 'Salads',
        incentivioId: 'inc-group-005',
        externalId: 'ext-id-group-005',
        locationName: 'Downtown Store',
        locationId: 'loc-001',
        price: 8990,
        status: 'ACTIVE',
        productId: 'prod-grp-006',
      },
    ],
  },
];

export const targetingGroups = {
  results: targetingGroupResults,
};
